import React from "react";
import AllUser from "../component/sections/user/manage/AllUser";
import middleware from "./middleware/middleware";

const sitesRoutes = [
  {
    path: "/user/manage/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllUser />,
        "AllUser"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
